import { Link } from "react-router-dom";
import { Heart as HeartIcon } from "../components/Decor";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="bg-candy-mist min-h-screen flex items-center justify-center p-6 text-center">
      <Seo title="Page Not Found" noindex />
      <div data-testid="not-found-page">
        <p className="font-display font-semibold text-7xl text-candy" data-testid="not-found-code">404</p>
        <h1 className="font-display font-semibold text-2xl mt-2">This stitch dropped off the hook!</h1>
        <p className="text-muted font-semibold mt-2">The page you're looking for doesn't exist — but lots of cozy things do.</p>
        <Link to="/" data-testid="not-found-home-link" className="mt-6 inline-block px-6 py-3 rounded-full bg-candy text-white font-bold shadow-pink hover:bg-candy-deep transition-colors duration-200">
          Back to the cozy side <HeartIcon className="inline w-4 h-4 ml-1" />
        </Link>
      </div>
    </div>
  );
}
